import { useEffect, useState } from 'react';
import { UserManager } from 'oidc-client-ts';
import { buildLinkPopupConfig } from '../auth/linkPopup';

/**
 * The Google popup's redirect target (W1.5), registered in Cognito as the
 * link-ceremony callback URL (contract: crossmarc-auth "add the link-ceremony
 * callback URL"). Runs entirely INSIDE the popup window, never the main tab.
 *
 * `signinPopupCallback()` doesn't need to share any state with the opener's
 * `UserManager` instance — it just relays this window's callback URL back to
 * whichever window opened it (via `postMessage`/`BroadcastChannel`, using
 * `window.opener`), and the OPENER's own `signinPopup()` call (still awaiting,
 * with the matching state already in ITS memory) resolves the OAuth exchange.
 * A fresh config here is only for the constructor's required fields; its
 * stores are never touched by this call.
 */
export function LinkPopupCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const manager = new UserManager(buildLinkPopupConfig());
    manager.signinPopupCallback().catch(() => {
      // The opener's signinPopup() promise carries the real failure back to
      // the ceremony UI; this only covers the (rare) case where the popup
      // can't even notify the opener — nothing to recover from here except
      // let the user close the window themselves.
      setError('Something went wrong finishing sign-in. You can close this window.');
    });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
      <p className="m-0 font-sans text-[13px] text-slate">
        {error ?? 'Finishing sign-in…'}
      </p>
    </div>
  );
}
